import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { actionTypes } from '../../../utils/mappings';
import { AppDispatchContext } from '../../../context/AppContext';
import ActionButton from './ActionButton';

const ActionOption = ({ option, device, kioskAction }) => {
    const dispatch = useContext(AppDispatchContext);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    if (!actionTypes[kioskAction]) {
        return null;
    }
    const title = t(actionTypes[kioskAction].text);
    const { pathname } = location || {};
    return (
        <ActionButton
            title={title}
            icon="chevron-right"
            id="kiosk-action-button"
            onClick={() => {
                dispatch({
                    type: 'SET_DEVICE',
                    device,
                    goBackLink: pathname,
                });
                navigate(option.href);
            }}
        />
    );
};

ActionOption.propTypes = {
    option: PropTypes.object.isRequired,
    device: PropTypes.object.isRequired,
    kioskAction: PropTypes.string.isRequired,
};

export default ActionOption;
